import PropTypes from 'prop-types';
import React from 'react';

class GroupDetail extends React.Component {

  render() {
    const { group } = this.props;
    const alerts = [];

    return (
      <div className="container">
        { alerts.length !== 0 && (
          <div className="row"><div className="col-md-8">{alerts}</div></div>)
        }
        <div className="row">
          <div className="col-md-4">
            <h3>{group.name}</h3>
            <h4>Members: {group.members_count}</h4>
          </div>
        </div>
      </div>
    );
  }
}


GroupDetail.propTypes = {
  group: PropTypes.object.isRequired,
};

export default GroupDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/GroupDetail.js